













import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import TransitionFade from "@/components/ui/transitions/TransitionFade.vue";
import { IdentifiedNotification } from "@/models/notification.model";
import { capitalizeFilter } from "@/filters/capitalize.filter";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

@Component({
  filters: {
    ...capitalizeFilter
  },
  components: { TransitionFade }
})
export default class NotificationWrapper extends Vue {
  @Action("ui/closeNotification") closeNotification!: (
    notificationId: string
  ) => void;
  @State(state => state.ui.notifications)
  notifications!: IdentifiedNotification[];

  get limitedNotifications(): IdentifiedNotification[] {
    return this.notifications.slice(0, this.maxNotificationsCount);
  }

  i18nMessageKeyEnum = I18nMessageKey;

  private maxNotificationsCount = 1;

  notificationHidden(notificationId: string): void {
    this.closeNotification(notificationId);
  }
}
